import { getWidth, aspectRatio } from './helper';

export type PowerSupplyPictogramTypes = 'Included' | 'NotIncluded' | 'Specification';

export type PowerSupplyPictogramProps = {
  type: PowerSupplyPictogramTypes;
  width?: string;
};

export const PowerSupplyPictogram = ({ type, width }: PowerSupplyPictogramProps) => (
  <div
    style={{
      width: getWidth(width),
      aspectRatio,
      fontSize: getWidth(width),
    }}
    className="[&>div]:border-color-black relative [&>div]:absolute [&>div]:rounded-[0.02em] [&>div]:border-[0.018em]"
  >
    {/* the left contact */}
    <div className="bottom-[75.6%] left-[34.8%] h-[14.4%] w-[6%] border-b-[0]!" />
    {/* the right contact */}
    <div className="right-[34.8%] bottom-[75.6%] h-[14.4%] w-[6%] border-b-[0]!" />
    {/* the contact holder */}
    <div className="bottom-[62.3%] left-[25.5%] h-[14.3%] w-[48.8%] border-b-[0]!" />
    {/* the body */}
    <div className="bottom-[10%] left-[13.5%] h-[53.4%] w-[72.9%]" />
    {/* the frame -> included/ not included */}
    {type === 'Included' || type === 'NotIncluded' ? <div className="inset-[1%]" /> : null}
    {/* the strike through -> not included */}
    {type === 'NotIncluded' ? (
      <div className="-top-[0.7%] left-[2.2%] h-0 w-[168.5%] origin-top-left rotate-54 rounded-full bg-[#000]" />
    ) : null}
  </div>
);
